import {
  JbButton
} from "./chunk.DPPOCK5V.js";
import {
  jb_alert_css_default
} from "./chunk.BBAI6RDO.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-alert/jb-alert.ts
var JbAlert = class extends Initiable(i) {
  constructor() {
    super(...arguments);
    this.ARIALABEL_DEFAULT = {
      close: "Close",
      logo: "Julius Baer Logo"
    };
  }
  static create(data) {
    const buttons = data.buttons.map(
      (option) => new JbButton().init({
        props: option,
        attributes: { slot: "buttons" }
      })
    );
    return new JbAlert().init({
      props: data,
      childNodes: [...buttons]
    });
  }
  unstacked() {
    this.remove();
  }
  _close() {
    this.dispatchEvent(new CustomEvent("jb-popup:close", { bubbles: true, composed: true }));
  }
  render() {
    return b`
      <!-- The name repeats the title rather than referencing it: aria-labelledby pointing at a
           jb-heading resolves to an empty name, because the text it renders is slotted into its
           shadow root. -->
      <div
        class="wrap"
        aria-label=${this.title}
        aria-modal="true"
        role="dialog"
      >
        <div class="logo-wrap">
          <jb-logo
            isWhite
            .svgLogo=${this.svgLogo}
            .ariaLabels=${{ logoLabel: this.ariaLabels?.logo || this.ARIALABEL_DEFAULT.logo }}
          ></jb-logo>
        </div>
        <div class="close-icon-wrap">
          <button
            @click=${this._close}
            aria-label=${this.ariaLabels?.close || this.ARIALABEL_DEFAULT.close}
          >
            <jb-icon
              iconName="material:close"
              size="large"
            ></jb-icon>
          </button>
        </div>
        <div class="text-wrap">
          ${this.title ? b`<jb-heading
                  class="title"
                  rank="1"
                  >${this.title}</jb-heading
                >` : A}
          <p class="content">${o(this.content)}</p>
          ${this.showLegend ? b`<p class="legend">${this.legend}</p>` : A}
        </div>
        <jb-button-panel .align=${"center"}><slot name="buttons"></slot></jb-button-panel>
      </div>
    `;
  }
};
JbAlert.styles = [reset_css_default, jb_alert_css_default];
__decorateClass([
  n({ type: Object })
], JbAlert.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbAlert.prototype, "content", 2);
__decorateClass([
  n()
], JbAlert.prototype, "legend", 2);
__decorateClass([
  n({ type: Boolean })
], JbAlert.prototype, "showLegend", 2);
__decorateClass([
  n()
], JbAlert.prototype, "svgLogo", 2);
__decorateClass([
  n()
], JbAlert.prototype, "title", 2);
JbAlert = __decorateClass([
  customElement("jb-alert")
], JbAlert);

export {
  JbAlert
};
